var map = {
	"./App.vue": "./src/App.vue",
	"./commonModule/pages/logo.vue": "./src/commonModule/pages/logo.vue",
	"./commonModule/views/addOrganDrug/index.vue": "./src/commonModule/views/addOrganDrug/index.vue",
	"./commonModule/views/addOrganDrug/updateOrganDrug.vue": "./src/commonModule/views/addOrganDrug/updateOrganDrug.vue",
	"./components/Pagination/index.vue": "./src/components/Pagination/index.vue",
	"./components/basic-container/main.vue": "./src/components/basic-container/main.vue",
	"./components/error-page/403.vue": "./src/components/error-page/403.vue",
	"./components/error-page/404.vue": "./src/components/error-page/404.vue",
	"./components/error-page/500.vue": "./src/components/error-page/500.vue",
	"./components/iframe/main.vue": "./src/components/iframe/main.vue",
	"./components/transfer/index.vue": "./src/components/transfer/index.vue",
	"./page/index/cooperation.vue": "./src/page/index/cooperation.vue",
	"./page/index/footer.vue": "./src/page/index/footer.vue",
	"./page/index/index.vue": "./src/page/index/index.vue",
	"./page/index/layout.vue": "./src/page/index/layout.vue",
	"./page/index/top.vue": "./src/page/index/top.vue",
	"./views/aboutYY/index.vue": "./src/views/aboutYY/index.vue",
	"./views/cliniNutrit/index.vue": "./src/views/cliniNutrit/index.vue",
	"./views/cooperation/index.vue": "./src/views/cooperation/index.vue",
	"./views/drugInfo/index.vue": "./src/views/drugInfo/index.vue",
	"./views/home/index.vue": "./src/views/home/index.vue",
	"./views/interHospital/index.vue": "./src/views/interHospital/index.vue",
	"./views/joinUs/index.vue": "./src/views/joinUs/index.vue",
	"./views/platformLogin/index.vue": "./src/views/platformLogin/index.vue",
	"./views/wisdomStore/index.vue": "./src/views/wisdomStore/index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/.*\\.vue$";